import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';
import {useNavigate} from 'react-router-dom';

import {useBillableEvents} from '../hooks/useBillableEvents.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";

export const RecordsTable = () => {
    const {columns} = useTableColumns();
    const navigate = useNavigate();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useBillableEvents();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    // Read-only (FNP-533): no selection / no edit drawer. Row click opens the
    // detail view. The BillableEvent id is a COMPOSITE key
    // (`billable-event:metering-record:<uuid>#meter:<code>#<iso>#_`) containing
    // `#`, `:` and `.` — unlike the UUID ids the peer modules navigate with. It
    // MUST be encodeURIComponent'd: a raw `#` is a URL fragment delimiter, so the
    // path would be truncated at the `#`, useParams().id would come back partial,
    // and getBillableEvent(<partial id>) returns nothing → the detail page hangs on
    // its loading spinner forever. react-router v6 useParams() auto-decodes, so the
    // detail page receives the original id. (Same applies to the sibling
    // observability modules FNP-534/535/536 — their ids are composite too.)
    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                onRowClick={({record}) => navigate(`/billable-events/${encodeURIComponent(record.id)}`)}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>
        </SimpleGrid>
    );
};
